import {SignalR} from '../../constants/actionType';
import {ConnectionStatus} from '../../constants/dataEnum';

const initialState = {
  deviceHubConnectionState: ConnectionStatus.IDLE,
  sessionIsTakenOver: false,
};

export default function signalRState(state = initialState, action = {}) {
  switch (action.type) {
    case SignalR.SET_SESSION_TAKEN_OVER:
      return {...state, sessionIsTakenOver: action.sessionIsTakenOver};
    case SignalR.SET_DEVICE_HUB_CONNECTION_STATE: {
      return {...state, deviceHubConnectionState: action.value};
    }
    default:
      return state;
  }
}
